import React, { useEffect } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
// import { ViewIcon, HamburgerIcon } from '@chakra-ui/icons';
import { useColorModeValue } from '../../components/ui/color-mode';
import { Header } from '../../components/shared/IndexHeader';
import InitialView from './InitialView';
import NoResultsView from './NoResultsView';
import CustomerDetailsTabs from './CustomerDetailsTabs';
import SearchBar from './SearchBar';
import CustomerCreationDialog from './CustomerCreationDialog';
// import UpdateComplaintDialog from './UpdateComplaintDialog';
// import ViewComplaintDialog from './ViewComplaintDialog';
import CustomerInfoSection from './CustomerInfoSection';
import CustomerSections from './CustomerSections';
import CollapsibleSection from './CollapsibleSection';

import { useDispatch, useSelector } from 'react-redux';
import { setIsOnComplaintRoute } from '../../store/complaintSlice';
import {
  clearUserState,
  getUserDataRequest,
} from '../../store/userSlice';
import { darkMode, lightMode } from '../../theme/config';
import { closeDialog, openDialog } from '../../store/dialogSlice';
import { resetCustomerData, setActiveTabForCustomerType, setSearchValue, getUser } from '../../store/customerSlice';
import FitTabs from '../../components/shared/tabs/Tabs';
import { useCustomerActions } from './useCustomerActions';
import { BsGrid, BsList } from 'react-icons/bs';

const CustomersIndex = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsOnComplaintRoute(false));
  }, [dispatch]);
  const dialogOpen = useSelector((state) => state.dialogs.createCustomer);
  // const viewComplaintDialog = useSelector((state) => state.dialogs.viewComplaint);
  // const updateComplaintDialog = useSelector((state) => state.dialogs.updateComplaint);
  const { searchValue, view, initiateUser } = useSelector((state) => state.customer);
  const { loading } = useSelector(state => ({ loading: state.user.loading }));

  const {
    handleEditProduct,
    handleRaiseComplaint,
    handleViewComplaint,
    handleEditComplaint,
    customer
  } = useCustomerActions();

  useEffect(() => {
    if (!searchValue || !initiateUser) return;
    dispatch(clearUserState());
    dispatch(resetCustomerData());
    if (/^\+?\d{7,15}$/.test(searchValue)) {
      dispatch(getUserDataRequest({ phoneNumber: searchValue }));
    } else {
      dispatch(getUserDataRequest({ email: searchValue }));
    };
  }, [initiateUser]);

  const bgColor = useColorModeValue(
    lightMode.boxBackgroundColor2,
    darkMode.inputBoxBorderColor
  );

  const CustomerDetailsColor = useColorModeValue(lightMode.customerDetailsColor, darkMode.customerDetailsColor);
  const backgroundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
  const borderColor = useColorModeValue(lightMode.hoverColor, darkMode.navbarBorderColor);
  const textColor = useColorModeValue(lightMode.inputTextColor, darkMode.inputTextColor);
  const activeTab = useSelector((state) => state.customer.activeTabType);

  const handleTabChange = (newTab) => {
    dispatch(setActiveTabForCustomerType(newTab.value));
  };

  const onSearchTermChange = (e) => {
    dispatch(setSearchValue(e.target.value));
  };

  const performSearch = () => {
    const term = searchValue.trim();
    if (!term) return;
    // // console.log('Performing search for:', term);
    dispatch(getUser(true))
  }

  const handleClose = () => dispatch(closeDialog('createCustomer'));
  const createNewCustomer = () => dispatch(openDialog('createCustomer'));

  const handleViewComplaintWrapper = (complaint) => {
    handleViewComplaint(complaint);
    dispatch(openDialog('viewComplaint'));
  };

  const handleEditComplaintWrapper = (complaint) => {
    handleEditComplaint(complaint);
    dispatch(openDialog('updateComplaint'));
  };

  // const closeUpdateComplaintDialog = () => dispatch(closeDialog('updateComplaint'));
  // const closeViewComplaintDialog = () => dispatch(closeDialog('viewComplaint'));

  const { firstName, lastName, email } = customer;

  const tabs = [
    {
      value: 'tabs',
      label: (
        <Flex align="center" gap={2}>
          <BsGrid />
          <Text>Tabs</Text>
        </Flex>
      ),
      panel: <CustomerDetailsTabs />,
    },
    {
      value: 'all',
      label: (
        <Flex align="center" gap={2}>
          <BsList />
          <Text>All</Text>
        </Flex>
      ),
      panel: (
        <Box>
          <Flex direction="column" mb={6}>
            <Header title={firstName && firstName + " " + lastName} />
            <Text fontSize="md" color={textColor} fontWeight="semibold">
              {email}
            </Text>
          </Flex>

          {/* Customer Details Section */}
          <CollapsibleSection
            title="Customer Details"
            defaultOpen={false}
          >
            <CustomerInfoSection customer={customer} />
          </CollapsibleSection>

          {/* Products and Complaints Sections */}
          <CustomerSections
            customer={customer}
            borderColor={borderColor}
            handleEditProduct={handleEditProduct}
            handleRaiseComplaint={handleRaiseComplaint}
            handleViewComplaint={handleViewComplaintWrapper}
            handleEditComplaint={handleEditComplaintWrapper}
          />
        </Box>
      ),
    },
  ];

  return (
    <Box border={{ base: '', md: '1px solid' }} borderColor={{ base: '', md: borderColor }} p={{ base: 0, md: 5 }} borderRadius="sm" bg={backgroundColor}>
      <Header title="Customer Search" />

      <SearchBar
        searchTerm={searchValue}
        onSearchTermChange={onSearchTermChange}
        onSearch={performSearch}
        isSearching={loading}
        createNewCustomer={createNewCustomer}
      />

      <Box
        bg={bgColor}
        p={{ base: 4, md: 10 }}
        borderRadius="md"
        boxShadow="0 0 5px rgba(0.1,0.1,0.1,0.1)"
        background={CustomerDetailsColor}
      >
        {view === 'initial' && <InitialView />}
        {view === 'noResults' && <NoResultsView />}
        {view === 'found' && (
          <FitTabs page="customer" tabs={tabs} value={activeTab} onChange={handleTabChange} fitted="false" width="100%" variant="enclosed" tabListToPageEnd={true} />
        )}
      </Box>

      <CustomerCreationDialog open={dialogOpen} onClose={handleClose} />
      {/* <UpdateComplaintDialog isOpen={updateComplaintDialog} onClose={closeUpdateComplaintDialog} />
      <ViewComplaintDialog isOpen={viewComplaintDialog} onClose={closeViewComplaintDialog} /> */}
    </Box>
  );
};

export default CustomersIndex;